import React from 'react';

export const TrackingLink = ({ url, title = 'Tracking Link' }) => {
  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      {title}
    </a>
  );
};
